// extracted by mini-css-extract-plugin
module.exports = {"layout":"about_layout__mhMne","hero":"about_hero__8n0R3","content":"about_content__AHuWX","filler":"about_filler__K1yJh"};